import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

const TABS = [
  { label: "Research Articles", to: "/ArticlesDashboard" },
  { label: "Projects", to: "/ProjectsDashboard" },
  { label: "Films", to: "/VideosDashboard" },
  { label: "Social", to: "/InstagramDashboard" },
  { label: "Gallery", to: "/GalleryDashboard" },
];

export default function AdminNavbar() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleLogout = () => {
    localStorage.removeItem("adminAuth");
    navigate("/login");
  };

  return (
    <header className="admin-topbar">
      <Link to="/ArticlesDashboard" className="brand">
        <span className="dot" />
        Anas Nasir
      </Link>

      <div className="admin-topbar-links">
        {TABS.map((t) => (
          <Link
            key={t.to}
            to={t.to}
            className={pathname.startsWith(t.to) ? "active" : ""}
          >
            {t.label}
          </Link>
        ))}
      </div>

      <button className="btn-logout" onClick={handleLogout}>
        Log out
      </button>
    </header>
  );
}
